var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2197,
    cy: 31,
    r: 30,
    stroke: "#CCAA60",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1799 35.8312C38.9818 35.6202 38.2825 34.9964 36.9968 34.171C35.7017 33.3385 34.7465 32.8193 34.4725 32.6983C34.4484 32.6876 34.4218 32.6836 34.3956 32.6869C34.3694 32.6902 34.3446 32.7006 34.3238 32.7169C33.8825 33.0611 33.1395 33.6933 33.0996 33.7274C32.8423 33.9479 32.8423 33.9479 32.6317 33.8792C32.2613 33.7578 31.1108 33.1468 30.1082 32.142C29.1056 31.1371 28.4632 29.9581 28.3418 29.5881C28.2723 29.3772 28.2723 29.3772 28.4935 29.1199C28.5277 29.08 29.1603 28.337 29.5045 27.8961C29.5208 27.8753 29.5311 27.8505 29.5344 27.8243C29.5377 27.7981 29.5338 27.7715 29.5231 27.7473C29.402 27.473 28.8829 26.5182 28.0503 25.2231C27.2238 23.9378 26.6007 23.2384 26.3897 23.0404C26.3704 23.0221 26.3464 23.0094 26.3205 23.0036C26.2945 22.9978 26.2674 22.9991 26.2421 23.0073C25.5046 23.2608 24.793 23.5842 24.1171 23.9731C23.4645 24.3524 22.8468 24.7886 22.2709 25.2766C22.2508 25.2937 22.2358 25.3159 22.2273 25.3409C22.2189 25.3659 22.2175 25.3927 22.2231 25.4185C22.3024 25.7881 22.6815 27.331 23.8579 29.4682C25.0582 31.6494 25.89 32.767 27.6526 34.5235C29.4153 36.2801 30.5681 37.162 32.7516 38.3623C34.8888 39.5386 36.4325 39.9181 36.8014 39.9967C36.8272 40.0023 36.8541 40.0008 36.8791 39.9924C36.9042 39.984 36.9265 39.9689 36.9437 39.9488C37.4316 39.373 37.8676 38.7553 38.2468 38.1027C38.6356 37.4267 38.959 36.7152 39.2126 35.9777C39.2207 35.9526 39.2219 35.9258 39.2162 35.9C39.2104 35.8742 39.1979 35.8505 39.1799 35.8312Z",
    fill: "#CCAA60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9764bfb52fce356c8dae26da74a58b57.svg";
export { ForwardRef as ReactComponent };